import mapActions from './mapActions';

export default mapActions('tool_categories', {
	fetchAll_url: () => '/api/tools/categories',
	create_url: () => '/api/tools/categories',
	update_url: (id) => `/api/tools/categories/${id}`,
	delete_url: (id) => `/api/tools/categories/${id}`,
});